@if (interaction()) {
    <div [ngClass]="injectedClass">
        <div class="row info adhere-left-edge">
            @if (imageNode()) {
                <div class="col-4">
                    <app-node-renderer [node]="imageNode()"></app-node-renderer>
                </div>
            }
            <div class="col">
                @for (node of textAndTitleContent(); track node) {
                    @if (node.NodeType === NodeType.Title) {
                        <app-node-renderer [node]="node"></app-node-renderer>
                    } @else {
                        <p id="interaction-message"><app-node-renderer [node]="node"></app-node-renderer></p>
                    }
                }
                @if (taskProgressNodes().length > 0) {
                    <div>
                        <strong>Requirements:</strong>
                        @for (node of taskProgressNodes(); track node) {
                            <div class="requirements">
                                <app-node-renderer [node]="node"></app-node-renderer>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
        @if (interaction().Responses && interaction().Responses.length > 0) {
            <div class="row adhere-left-edge">
                <div class="col">
                    <div class="responses-container">
                        @for (reply of interaction().Responses; track reply) {
                            @if (!isLinkReply(reply)) {
                                <button
                                    type="button"
                                    class="btn shadow-sm"
                                    [ngClass]="{
                                        'btn-secondary btn-xl': interaction().Responses.length == 1,
                                        'btn-secondary order-last': reply.DisplayMetadata.IsPrimaryOption,
                                        'btn-danger order-first': reply.DisplayMetadata.IsDangerOption,
                                        'btn-light': !reply.DisplayMetadata.IsDangerOption && !reply.DisplayMetadata.IsPrimaryOption
                                    }"
                                    (click)="sendReply(reply)">
                                    {{ reply.OptionText }}
                                </button>
                            }
                            @if (isLinkReply(reply)) {
                                <div style="flex-basis: 100%; height: 0"></div>
                                <a (click)="sendReply(reply)">
                                    {{ reply.OptionText }}
                                </a>
                                <div style="flex-basis: 100%; height: 0"></div>
                            }
                        }
                    </div>
                </div>
            </div>
        }
        @if (interaction().Quests && interaction().Quests.length > 0) {
            @for (newQuest of interaction().Quests; track newQuest; let i = $index) {
                <div class="quest-list">
                    <h3 class="h6 text-uppercase">Quests</h3>
                    @if (!newQuest.interactorDisabled) {
                        <div class="accordion accordion-flush" [id]="'questAccordion' + i">
                            <div class="accordion-item">
                                <h4 class="h5 accordion-header" [id]="'heading' + i">
                                    <button
                                        class="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        [attr.data-bs-target]="'#collapse' + i"
                                        aria-expanded="false"
                                        [attr.aria-controls]="'collapse' + i">
                                        <strong>{{ firstText(newQuest.Content) }}</strong>
                                    </button>
                                </h4>
                                <div
                                    [id]="'collapse' + i"
                                    class="accordion-collapse collapse"
                                    [attr.aria-labelledby]="'heading' + i"
                                    [attr.data-bs-parent]="'#questAccordion' + i">
                                    <div class="accordion-body">
                                        <app-interactor
                                            [injectedInteraction]="newQuest"
                                            [injectedClass]="'nested-quest-preview'"
                                            [parentInteraction]="this"
                                            [newChain]="true"
                                            [breadcrumb]="this.breadcrumb"></app-interactor>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }
        }
        <!----the ugliest if test of all time-->
        @if (
            interaction() &&
            ((interaction().PlayerStateUpdate &&
                (interaction().PlayerStateUpdate.CashChangedAmount ||
                    (interaction().PlayerStateUpdate.AddedItems && interaction().PlayerStateUpdate.AddedItems.length > 0) ||
                    (interaction().PlayerStateUpdate.RemovedItems && interaction().PlayerStateUpdate.RemovedItems.length > 0))) ||
                (interaction().PetChanges && interaction().PetChanges.length > 0))
        ) {
            <div class="row results-container">
                <div class="col-auto">
                    <div id="interaction-view" class="results card">
                        <app-critter-state-update [stateUpdate]="interaction()"></app-critter-state-update>
                    </div>
                </div>
            </div>
        }
    </div>
}
